export const UPDATE_MICORE_MODULE_PERMISSIONS_PARAMS_MICORESHARED="UPDATE_MICORE_MODULE_PERMISSIONS_PARAMS_MICORESHARED"

export const GET_INSURED_INFORMATION_MASTERS_END_MICORESHARED="GET_INSURED_INFORMATION_MASTERS_END_MICORESHARED"
export const GET_MICORE_MASTERS_END_MICORESHARED="GET_MICORE_MASTERS_END_MICORESHARED"
export const UPDATE_PRODUCT_BY_PRODUCT_TYPE_MICORESHARED="UPDATE_PRODUCT_BY_PRODUCT_TYPE_MICORESHARED"
export const GET_STATUS_MASTER_END_MICORESHARED="GET_STATUS_MASTER_END_MICORESHARED"
export const GET_USER_MASTERS_END_MICORESHARED='GET_USER_MASTERS_END_MICORESHARED'

export const GET_AGENT_MASTERS_END_MICORESHARED = "GET_AGENT_MASTERS_END_MICORESHARED"
export const CLEAR_POLICY_SEARCH_PARAMS_MICORESHARED = "CLEAR_POLICY_SEARCH_PARAMS_MICORESHARED"

export const UPDATE_POLICY_SEARCH_RESULT_MICORESHARED = "UPDATE_POLICY_SEARCH_RESULT_MICORESHARED"
export const SHOW_SEARCH_RESULTS_MICORESHARED = "SHOW_SEARCH_RESULTS_MICORESHARED"
export const SHOW_TABLE_SEARCH_RESULTS_MICORESHARED = "SHOW_TABLE_SEARCH_RESULTS_MICORESHARED"
export const UPDATE_POLICY_SEARCH_PARAMS_MICORESHARED = "UPDATE_POLICY_SEARCH_PARAMS_MICORESHARED"
export const INIT_POLICY_SEARCH = "INIT_POLICY_SEARCH_MICORESHARED"
export const UPDATE_ENDORSEMENT_PARAMS_CHANGE = "UPDATE_ENDORSEMENT_PARAMS_CHANGE_MICORESHARED"
export const UPDATE_NEW_ENDORSEMENT_POLICY_EXPIRY_DATE = "UPDATE_NEW_ENDORSEMENT_POLICY_EXPIRY_DATE"
export const CLEAR_ENDORSEMENT_PARAMS = "CLEAR_ENDORSEMENT_PARAMS_MICORESHARED"
export const FILTER_ENDORSMENT_MASTER = "FILTER_ENDORSMENT_MASTER"

export const UPDATE_IS_ACCOUNT_CODE_GENERATION = "UPDATE_IS_ACCOUNT_CODE_GENERATION"
export const UPDATE_ACCOUNT_DETAILS_PARAMS = "UPDATE_ACCOUNT_DETAILS_PARAMS_MICORESHARED"
export const UPDATE_ACCOUNT_DETAILS_PARAMS_IN_ENDORSEMENT = "UPDATE_ACCOUNT_DETAILS_PARAMS_IN_ENDORSEMENT_MICORESHARED"
export const GET_ACCOUNT_DETAILS_END = "GET_ACCOUNT_DETAILS_END_MICORESHARED"


export const CLEAR_ACCOUNT_DETAILS_PARAMS = "CLEAR_ACCOUNT_DETAILS_PARAMS_MICORESHARED"
export const CLEAR_ACCOUNT_DETAILS_IN_ENDORSEMENT = "CLEAR_ACCOUNT_DETAILS_IN_ENDORSEMENT_MICORESHARED"

export const GET_SUB_GRID_END = "GET_SUB_GRID_END_MICORESHARED"
export const CLEAR_SUB_GRID = "CLEAR_SUB_GRID_MICORESHARED"
export const UPDATE_MODAL_DISPLAY_STATE = "UPDATE_MODAL_DISPLAY_STATE"
export const GET_REGULATORY_BY_EMIRATE_END='GET_REGULATORY_BY_EMIRATE_END'

export const UPDATE_CHECKLIST_PARAMS = "UPDATE_CHECKLIST_PARAMS"
export const GET_CHECKLIST_END = "GET_CHECKLIST_END"

export const RESET_MODAL_STATE="RESET_MODAL_STATE"
export const UPDATE_MATERNITY_VALUES_BY_EMIRATE_END_MICORESHARED = 'UPDATE_MATERNITY_VALUES_BY_EMIRATE_END_MICORESHARED'
/*********************** Member Page ***********************/

export const GO_TO_POLICY_MEMBER_INFORMATION_MICORESHARED = "GO_TO_POLICY_MEMBER_INFORMATION_MICORESHARED"
export const GET_SUBGROUP_MASTERS_END = "GET_SUBGROUP_MASTERS_END"
export const GET_RELATION_MASTERS_END_MICORESHARED = "GET_RELATION_MASTERS_END_MICORESHARED"
export const UPDATE_ALL_MEMBER_CHECKBOX_PARAMS_MICORESHARED = "UPDATE_ALL_MEMBER_CHECKBOX_PARAMS_MICORESHARED"
export const UPDATE_ALL_MEMBER_IN_PAGE_CHECKBOX_PARAMS_MICORESHARED = "UPDATE_ALL_MEMBER_IN_PAGE_CHECKBOX_PARAMS_MICORESHARED"
export const UPDATE_MEMBER_CHECKBOX_PARAMS_MICORESHARED = "UPDATE_MEMBER_CHECKBOX_PARAMS_MICORESHARED"
export const UPDATE_HAS_CHECKBOX_IN_MEMBER_DETAILS_MICORESHARED ="UPDATE_HAS_CHECKBOX_IN_MEMBER_DETAILS_MICORESHARED"
export const UPDATE_IS_ADDITION_OF_MEMBER = "UPDATE_IS_ADDITION_OF_MEMBER";
export const UPDATE_MEMBER_TABLE_SEARCH_PARAMS_MICORESHARED = "UPDATE_MEMBER_TABLE_SEARCH_PARAMS_MICORESHARED"
export const UPDATE_MEMBERS_MICORESHARED = "UPDATE_MEMBERS_MICORESHARED"
export const GET_PAGED_MEMBERS_MICORESHARED = "GET_PAGED_MEMBERS_MICORESHARED"
export const SHOW_MEMBERS_MICORESHARED = "SHOW_MEMBERS_MICORESHARED"
export const GET_POLICY_DISTINCT_MEMBER_IMPORT_PAGE_ID_MICORESHARED = "GET_POLICY_DISTINCT_MEMBER_IMPORT_PAGE_ID_MICORESHARED"
export const POLICY_UPDATE_CURRENT_MEMBER_NAME_MICORESHARED = "POLICY_UPDATE_CURRENT_MEMBER_NAME_MICORESHARED"
export const GET_MEMBER_DETAILS_END_MICORESHARED = "GET_MEMBER_DETAILS_END_MICORESHARED"
export const SHOW_MEMBER_DEPENDENTS_MICORESHARED = "SHOW_MEMBER_DEPENDENTS_MICORESHARED"
export const SHOW_MEMBER_DETAILS_MICORESHARED = "SHOW_MEMBER_DETAILS_MICORESHARED"
export const COLLAPSE_POLICY_MEMBER_INFORMATION_MICORESHARED = "COLLAPSE_POLICY_MEMBER_INFORMATION_MICORESHARED"
export const POLICY_GET_VISA_LOCATION_MASTER_END_MICORESHARED = "POLICY_GET_VISA_LOCATION_MASTER_END_MICORESHARED"
export const POLICY_GET_WORK_LOCATION_MASTER_END_MICORESHARED = "POLICY_GET_WORK_LOCATION_MASTER_END_MICORESHARED"
export const POLICY_GET_RESIDENT_LOCATION_MASTER_END_MICORESHARED = "POLICY_GET_RESIDENT_LOCATION_MASTER_END_MICORESHARED"
export const SHOW_DEPENDENT_DETAILS_MICORESHARED = "SHOW_DEPENDENT_DETAILS_MICORESHARED"
export const CLEAR_POLICY_DOCUMENT_LIST_MICORESHARED = "CLEAR_POLICY_DOCUMENT_LIST_MICORESHARED"
export const UPDATE_CURRENT_POLICY_MEMBER_ID_MICORESHARED = "UPDATE_CURRENT_POLICY_MEMBER_ID_MICORESHARED"
export const UPDATE_CURRENT_MEMBER_TYPE_MICORESHARED = "UPDATE_CURRENT_MEMBER_TYPE_MICORESHARED"
export const CALCULATE_HAAD_PENALTY_END_MICORESHARED = "CALCULATE_HAAD_PENALTY_END_MICORESHARED"
export const UPDATE_CHANGE_OF_CATEGORY_HAS_ERROR_MICORESHARED = "UPDATE_CHANGE_OF_CATEGORY_HAS_ERROR_MICORESHARED"

export const POLICY_CALCULATE_BMI_END_MICORESHARED = "POLICY_CALCULATE_BMI_END_MICORESHARED"
export const UPDATE_POLICY_MEMBER_IS_LOCATION_MANDATORY_MICORESHARED = "UPDATE_POLICY_MEMBER_IS_LOCATION_MANDATORY_MICORESHARED"
export const POLICY_SHOW_DUBAI_REGION_PARAMS_MICORESHARED = "POLICY_SHOW_DUBAI_REGION_PARAMS_MICORESHARED"
export const POLICY_SHOW_ABUDHABI_REGION_PARAMS_MICORESHARED = "POLICY_SHOW_ABUDHABI_REGION_PARAMS_MICORESHARED"
export const POLICY_CHECK_VISA_TYPE_MICORESHARED = "POLICY_CHECK_VISA_TYPE_MICORESHARED"
export const UPDATE_POLICY_MEMBER_INFORMATION_PARAMS_MICORESHARED = "UPDATE_POLICY_MEMBER_INFORMATION_PARAMS_MICORESHARED"
export const POLICY_UPDATE_MEMBER_VERIFIED_PARAM_MICORESHARED = "POLICY_UPDATE_MEMBER_VERIFIED_PARAM_MICORESHARED"
export const CLEAR_POLICY_MEMBER_INFORMATION_PARAMS_MICORESHARED = "CLEAR_POLICY_MEMBER_INFORMATION_PARAMS_MICORESHARED"
export const GET_POLICY_PRINCIPAL_MASTERS_END_MICORESHARED = "GET_POLICY_PRINCIPAL_MASTERS_END_MICORESHARED"
export const UPDATE_SALARY_VALIDATION_END_MICORESHARED = "UPDATE_SALARY_VALIDATION_END_MICORESHARED"
export const UPDATE_IS_PRINCIPAL_END_MICORESHARED = "UPDATE_IS_PRINCIPAL_END_MICORESHARED"
export const UPDATE_MEMBER_AGE_MICORESHARED = "UPDATE_MEMBER_AGE_MICORESHARED"
export const UPDATE_TPADOWNLOAD_PARAMS_CHANGE = "UPDATE_TPADOWNLOAD_PARAMS_CHANGE"
export const RESET_TPA_DOWNLOAD_EXCEL = "RESET_TPA_DOWNLOAD_EXCEL"

export const UPDATE_FIRST_POLICY_PARAMS_MICORESHARED = "UPDATE_FIRST_POLICY_PARAMS_MICORESHARED"
export const UPDATE_MEMBER_PREMIUM_INFORMATION_END_MICORESHARED = "UPDATE_MEMBER_PREMIUM_INFORMATION_END_MICORESHARED"
export const UPDATE_MEMBER_UW_LOADING_CHANGE_END_MICORESHARED = "UPDATE_MEMBER_UW_LOADING_CHANGE_END_MICORESHARED"
export const UPDATE_MEMBER_DISCOUNT_CHANGE_END_MICORESHARED = "UPDATE_MEMBER_DISCOUNT_CHANGE_END_MICORESHARED"
export const UPDATE_MEMBER_AUTO_LOADING_CHANGE_END_MICORESHARED = "UPDATE_MEMBER_AUTO_LOADING_CHANGE_END_MICORESHARED"
export const WAIVE_OFF_FINAL_PENALTY_MICORESHARED = 'WAIVE_OFF_FINAL_PENALTY_MICORESHARED'

export const GET_TAX_MASTERS_END_MICORESHARED = "GET_TAX_MASTERS_END_MICORESHARED"
export const UPDATE_HAAD_PENALTY_CHECKBOX_PARAMS_POLICY = "UPDATE_HAAD_PENALTY_CHECKBOX_PARAMS_POLICY"


/* Documents Tab */
export const POLICY_CHECK_DOCUMENT_TAB_TYPE_MICORESHARED = "POLICY_CHECK_DOCUMENT_TAB_TYPE_MICORESHARED"
export const POLICY_GET_DISTINCT_DOCUMENT_PAGE_ID_MICORESHARED= "POLICY_GET_DISTINCT_DOCUMENT_PAGE_ID_MICORESHARED"
export const GET_POLICY_DOCUMENT_LIST_END_MICORESHARED = "GET_POLICY_DOCUMENT_LIST_END_MICORESHARED"
export const GET_POLICY_DOCUMENT_MASTERS_END_MICORESHARED= "GET_POLICY_DOCUMENT_MASTERS_END_MICORESHARED"
export const POLICY_GET_MEMBER_DOCUMENT_LIST_END_MICORESHARED = "POLICY_GET_MEMBER_DOCUMENT_LIST_END_MICORESHARED"
export const POLICY_GET_MEMBER_DOCUMENT_MASTERS_END_MICORESHARED = "POLICY_GET_MEMBER_DOCUMENT_MASTERS_END_MICORESHARED"
export const ADD_NEW_DOCUMENT_MICORESHARED = "ADD_NEW_DOCUMENT_MICORESHARED"
export const UPDATE_FILE_CHANGE_END_MICORESHARED = "UPDATE_FILE_CHANGE_END_MICORESHARED"
export const UPDATE_DOCUMENT_PARAMS_END_MICORESHARED = "UPDATE_DOCUMENT_PARAMS_END_MICORESHARED"
export const UPDATE_DOCUMENT_CHECKBOX_PARAMS_MICORESHARED = "UPDATE_DOCUMENT_CHECKBOX_PARAMS_MICORESHARED"
export const DELETE_DOCUMENT_FROM_GRID_MICORESHARED = "DELETE_DOCUMENT_FROM_GRID_MICORESHARED"
export const UPDATE_DOCUMENTS_TABLE_ID_MICORESHARED = "UPDATE_DOCUMENTS_TABLE_ID_MICORESHARED"

/*Policy Information*/
export const UPDATE_POLICY_EXPIRY_DATE_MICORESHARED="UPDATE_POLICY_EXPIRY_DATE_MICORESHARED"
export const UPDATE_POLICY_INFORMATION_PARAMS_MICORESHARED='UPDATE_POLICY_INFORMATION_PARAMS_MICORESHARED'
export const UPDATE_POLICY_INSURED_INFORMATION_CODES_MICORESHARED="UPDATE_POLICY_INSURED_INFORMATION_CODES_MICORESHARED"
export const ADD_POLICY_INSURED_CODE_FROM_INSURED_INFORAMATION_MICORESHARED='ADD_POLICY_INSURED_CODE_FROM_INSURED_INFORAMATION_MICORESHARED'
export const UPDATE_CURRENT_POLICY_ID_MICORESHARED='UPDATE_CURRENT_POLICY_ID_MICORESHARED'
export const UPDATE_POLICY_INSURED_TYPE_INDIVIDUAL_MICORESHARED='UPDATE_POLICY_INSURED_TYPE_INDIVIDUAL_MICORESHARED'
export const UPDATE_POLICY_PROSPECT_TYPE_INDIVIDUAL_MICORESHARED = 'UPDATE_POLICY_PROSPECT_TYPE_INDIVIDUAL_MICORESHARED'
export const COLLAPSE_POLICY_SEARCH_RESULT_MICORESHARED='COLLAPSE_POLICY_SEARCH_RESULT_MICORESHARED'
export const COLLAPSE_POLICY_SEARCH_MICORESHARED='COLLAPSE_POLICY_SEARCH_MICORESHARED'
export const CLEAR_POLICY_INFORMATION_PARAMS_MICORESHARED='CLEAR_POLICY_INFORMATION_PARAMS_MICORESHARED'
export const GET_POLICY_INSURED_INFORMATION_END_MICORESHARED='GET_POLICY_INSURED_INFORMATION_END_MICORESHARED'
export const GET_POLICY_PROSPECT_INFORMATION_END_MICORESHARED = "GET_POLICY_PROSPECT_INFORMATION_END_MICORESHARED"
export const GET_CURRENT_POLICY_INFORMATION_END_MICORESHARED='GET_CURRENT_POLICY_INFORMATION_END_MICORESHARED'
export const HIDE_POLICY_INSURED_CODE_BUTTON_MICORESHARED='HIDE_POLICY_INSURED_CODE_BUTTON_MICORESHARED'
export const GET_CATEGORY_DETAILS_BY_PROPOSAL_END_MICORESHARED ='GET_CATEGORY_DETAILS_BY_PROPOSAL_END_MICORESHARED'
export const UPDATE_EDITABLE_FEILDS_MICORESHARED='UPDATE_EDITABLE_FEILDS_MICORESHARED'
export const UPDATE_TAB_MODAL_DISPLAY_STATE ='UPDATE_TAB_MODAL_DISPLAY_STATE'
export const GET_POLICY_TOB_MASTER_END_MICORESHARED='GET_POLICY_TOB_MASTER_END_MICORESHARED'
export const UPDATE_POLICY_TOB_PARAMS_MICORESHARED='UPDATE_POLICY_TOB_PARAMS_MICORESHARED'
export const GET_CATEGORY_MASTERS_END_MICORESHARED="GET_CATEGORY_MASTERS_END_MICORESHARED"
export const GET_POLICY_LOADING_DISTRIBUTION_END_MICORESHARED='GET_POLICY_LOADING_DISTRIBUTION_END_MICORESHARED'
export const GET_POLICY_BASE_BENEFIT_MASTER_END_MICORESHARED ='GET_POLICY_BASE_BENEFIT_MASTER_END_MICORESHARED'
export const GET_POLICY_COSTING_SHEET_END_MICORESHARED="GET_POLICY_COSTING_SHEET_END_MICORESHARED"
export const GET_POLICY_COSTING_SHEET_DETAILS_PAGED_RESULT_MICORESHARED='GET_POLICY_COSTING_SHEET_DETAILS_PAGED_RESULT_MICORESHARED'
export const UPDATE_POLICY_INSURED_INFORMATION_PARAMS_MICORESHARED='UPDATE_POLICY_INSURED_INFORMATION_PARAMS_MICORESHARED'
export const UPDATE_POLICY_CUSTOMER_AGE_MICORESHARED="UPDATE_POLICY_CUSTOMER_AGE_MICORESHARED"
export const CLEAR_POLICY_INSURED_INFORMATION_PARAMS_MICORESHARED='CLEAR_POLICY_INSURED_INFORMATION_PARAMS_MICORESHARED'
export const UPDATE_POLICY_SORT_PARAMETER_MICORESHARED="UPDATE_POLICY_SORT_PARAMETER_MICORESHARED"
export const UPDATE_POLICY_MEMBER_SORT_PARAMETER_MICORESHARED="UPDATE_POLICY_MEMBER_SORT_PARAMETER_MICORESHARED"
export const UPDATE_INIT_OPTIONS='UPDATE_INIT_OPTIONS'
export const SHOW_ADD_TO_POLICY_INFORMATION="SHOW_ADD_TO_POLICY_INFORMATION"
export const ADD_INSURED_CODE_FROM_INSURED_INFORAMATION_MICORESHARED="ADD_INSURED_CODE_FROM_INSURED_INFORAMATION_MICORESHARED"
export const RESET_INSURED_CODE_INFORMATION_MICORESHARED="RESET_INSURED_CODE_INFORMATION_MICORESHARED"
export const RESET_ENDORSEMENT_SEARCH_STATE='RESET_ENDORSEMENT_SEARCH_STATE'
export const UPDATE_INSTALLMENT_PARAMS='UPDATE_INSTALLMENT_PARAMS'
/* summary page components starts*/ 
export const GET_POLICY_SUMMARY_END="GET_POLICY_SUMMARY_END_MICORESHARED"
export const GET_POLICY_MEMBER_PREMIUM_DETAILS_END="GET_POLICY_MEMBER_PREMIUM_DETAILS_END_MICORESHARED"
export const UPDATE_STAGE_STATUS_CHANGE_POLICY = "UPDATE_STAGE_STATUS_CHANGE_POLICY"
export const GET_SUMMARY_PAGE_STATUS_MASTER_END_POLICY = "GET_SUMMARY_PAGE_STATUS_MASTER_END_POLICY"


//--------Member Premium
export const UPDATE_MEMBER_PREMIUM_PARAMS="UPDATE_MEMBER_PREMIUM_PARAMS_MICORESHARED"
export const CALCULATE_GROSS_PREMIUM="CALCULATE_GROSS_PREMIUM_MICORESHARED"
export const UPDATE_MEMBER_PREMIUM_SEARCH_PARAMS="UPDATE_MEMBER_PREMIUM_SEARCH_PARAMS_MICORESHARED"

//--------Brpkerage
export const UPDATE_BROKERAGE_INFORMATION_PARAMS="UPDATE_BROKERAGE_INFORMATION_PARAMS_MICORESHARED"
export const UPDATE_BROKERAGE_SELF_BILLING_CHANGE="UPDATE_BROKERAGE_SELF_BILLING_CHANGE_MICORESHARED"
export const CLEAR_BROKERAGE_INFORMATION_PARAMS="CLEAR_BROKERAGE_INFORMATION_PARAMS_MICORESHARED"
//--------TPA
export const UPDATE_TPA_FEE_PARAMS="UPDATE_TPA_FEE_PARAMS_MICORESHARED"
export const UPDATE_TPA_SELF_BILLING_CHANGE="UPDATE_TPA_SELF_BILLING_CHANGE_MICORESHARED"
export const CLEAR_TPA_FEE_PARAMS="CLEAR_TPA_FEE_PARAMS_MICORESHARED"

/* summary page components ends*/ 

/* endorsement Startd*/ 
export const GET_CURRENT_ENDORSEMENT_END="GET_CURRENT_ENDORSEMENT_END_MICORESHARED"

/*endorsement ends*/ 
export const RESET_ENDORSEMENT_MODULE_STATE="RESET_ENDORSEMENT_MODULE_STATE_MICORESHARED"

/****member IMport */
export const UPDATE_POLICY_FILE_CHANGE_END_MICORESHARED ='UPDATE_POLICY_FILE_CHANGE_END_MICORESHARED'
export const GET_MEMBER_DETAILS_PAGED_RESULT_MICORESHARED='GET_MEMBER_DETAILS_PAGED_RESULT_MICORESHARED'
export const GET_POLICY_MEMBER_DETAILS_END_MICORESHARED='GET_POLICY_MEMBER_DETAILS_END_MICORESHARED'
export const GET_POLICY_MEMBER_DETAILS_STATUS_CHECK_MICORESHARED='GET_POLICY_MEMBER_DETAILS_STATUS_CHECK_MICORESHARED'
export const RESET_UPLOAD_MEMBER_DATA_MICORESHARED='RESET_UPLOAD_MEMBER_DATA_MICORESHARED'


/*dha dho etc. Verification starts*/
export const UPDATE_DOH_BATCH_LISTING_CHECKBOX_STATE='UPDATE_DOH_BATCH_LISTING_CHECKBOX_STATE_MICORESHARED'
export const UPDATE_SHAHFAFIYA_BATCH_LISTING_CHECKBOX_STATE='UPDATE_SHAHFAFIYA_BATCH_LISTING_CHECKBOX_STATE_MICORESHARED'

export const GET_VERIFICATION_BATCH_LISTING_END='GET_VERIFICATION_BATCH_LISTING_END_MICORESHARED'
export const GET_CURRENT_DOH_MEMBER_INFO_END='GET_CURRENT_DOH_MEMBER_INFO_END_MICORESHARED'
export const UPDATE_CURRENT_BATCH_PARAMS='UPDATE_CURRENT_BATCH_PARAMS_MICORESHARED'
export const GET_DOH_MEMBER_BY_ID_END='GET_DOH_MEMBER_BY_ID_END_MICORESHARED'
export const UPDATE_DOH_MEMBER_INFO_PARAMS='UPDATE_DOH_MEMBER_INFO_PARAMS_MICORESHARED'
export const UPDATE_DOH_MEMBER_SEARCH_PARAMS='UPDATE_DOH_MEMBER_SEARCH_PARAMS_MICORESHARED'


export const GET_DHA_MEMBER_BY_ID_END='GET_DHA_MEMBER_BY_ID_END_MICORESHARED'
export const UPDATE_DHA_MEMBER_INFO_PARAMS='UPDATE_DHA_MEMBER_INFO_PARAMS_MICORESHARED'
export const GET_CURRENT_DHA_MEMBER_INFO_END='GET_CURRENT_DHA_MEMBER_INFO_END_MICORESHARED'

/*dha dho etc. Verification ends*/ 
export const UPDATE_MEDICAL_CARDS_BATCH_FILE_CHANGE_END='UPDATE_MEDICAL_CARDS_BATCH_FILE_CHANGE_END_MICORESHARED'
export const CLEAR_MEDICAL_CARDS_BATCH_FILE_CHANGE='CLEAR_MEDICAL_CARDS_BATCH_FILE_CHANGE_MICORESHARED'
export const MEDICAL_CARDS_BATCH_INFO_CHANGE='MEDICAL_CARDS_BATCH_INFO_CHANGE_MICORESHARED'
export const UPLOAD_MEDICAL_CARD_BATCH_END='UPLOAD_MEDICAL_CARD_BATCH_END_MICORESHARED'

export const GET_INSTALLMENT_PREMIUM_END="GET_INSTALLMENT_PREMIUM_END"
export const CLEAR_ACCOUNT_DETAILS_IN_INSTALLMENTS="CLEAR_ACCOUNT_DETAILS_IN_INSTALLMENTS"
export const UPDATE_INSTALLMENT_CURRENT_ID="UPDATE_INSTALLMENT_CURRENT_ID"
export const RESET_INSTALLMENTS="RESET_INSTALLMENTS"
export const UPDATE_SUBGROUP_BILLING_PARAMS="UPDATE_SUBGROUP_BILLING_PARAMS"
export const UPDATE_SUBGROUP_CURRENT_ID="UPDATE_SUBGROUP_CURRENT_ID"
export const GET_SUBGROUP_BILLING_END="GET_SUBGROUP_BILLING_END"
export const RESET_SUBGROUP_BILLING="RESET_SUBGROUP_BILLING"
export const DELETE_SUBGROUP_BILLING_ROW="DELETE_SUBGROUP_BILLING_ROW"
export const ADD_NEW_SUBGROUP_BILLING_ROW="ADD_NEW_SUBGROUP_BILLING_ROW"
export const UPDATE_ALL_SUBGROUP_TABLE_CHECKBOX_PARAMS="UPDATE_ALL_SUBGROUP_TABLE_CHECKBOX_PARAMS"
export const UPDATE_SUBGROUP_TABLE_CHECKBOX_PARAMS="UPDATE_SUBGROUP_TABLE_CHECKBOX_PARAMS"

export const UPDATE_PREMIUM_BIFURCATION_PARAMS="UPDATE_PREMIUM_BIFURCATION_PARAMS"
export const RESET_PREMIUM_BIFURCATION="RESET_PREMIUM_BIFURCATION"
export const GET_PREMIUM_BIFURCATION_END="GET_PREMIUM_BIFURCATION_END"
export const GET_VAT_RATE_AND_PERC_MASTERS_END="GET_VAT_RATE_AND_PERC_MASTERS_END"
export const RESET_COMMUNICATION="RESET_COMMUNICATION"
export const GET_COMMUNICATION_VALUES_END="GET_COMMUNICATION_VALUES_END"
export const UPDATE_REMARKS_PARAMS="UPDATE_REMARKS_PARAMS"
export const RESET_REMARKS="RESET_REMARKS"
export const GET_REMARKS_VALUES_END="GET_REMARKS_VALUES_END"
export const UPDATE_COMMUNICATION_PARAMS="UPDATE_COMMUNICATION_PARAMS"


export const UPDATE_CHARGES_ID="UPDATE_CHARGES_ID_GROUP_MICORESHARED"
export const DELETE_CHARGES_ROW="DELETE_CHARGES_ROW_GROUP_MICORESHARED"
export const ADD_CHARGES_NEW_ROW="ADD_CHARGES_NEW_ROW_GROUP_MICORESHARED"
export const UPDATE_MANUAL_CHARGE_PROPS_SUMMARY="UPDATE_MANUAL_CHARGE_PROPS_SUMMARY_GROUP_MICORESHARED"
export const UPDATE_CHARGES_TABLE_PARAMS_IN_SUMMARY="UPDATE_CHARGES_TABLE_PARAMS_IN_SUMMARY_GROUP_MICORESHARED"
export const UPDATE_TOTAL_CHARGES_END="UPDATE_TOTAL_CHARGES_END_MICORESHARED"
export const VALIDATE_SUMMARY_CHARGES_END="VALIDATE_SUMMARY_CHARGES_END_MICORESHARED"

export const SEARCH_IN_COSTING_SHEET_BY_PARAMS="SEARCH_IN_COSTING_SHEET_BY_PARAMS_MICORESHARED"
export const UPDATE_COSTING_SHEET_SEARCH_PARAMS="UPDATE_COSTING_SHEET_SEARCH_PARAMS_MICORESHARED"

/*Member Search Filter*/ 
export const UPDATE_MEMBER_SEARCH_TAB = "UPDATE_MEMBER_SEARCH_TAB"
export const UPDATE_MEMBER_SEARCH_FILTER_PARAMS = "UPDATE_MEMBER_SEARCH_FILTER_PARAMS"
export const UPDATE_SEARCH_MEMBER_RESULTS = "UPDATE_SEARCH_MEMBER_RESULTS"
export const UPDATE_CHECKBOX_CHANGE_MEMBER_SEARCH_TABLE = "UPDATE_CHECKBOX_CHANGE_MEMBER_SEARCH_TABLE"
export const RESET_SEARCH_MEMBER_TABLE = "RESET_SEARCH_MEMBER_TABLE"
export const RESET_MEMBER_SEARCH_FILTER_PARAMS = "RESET_MEMBER_SEARCH_FILTER_PARAMS"
export const RESET_MEMBER_SEARCH = "RESET_MEMBER_SEARCH"
 


export const UPDATE_PAYMENT_TRANSACTION_PARAMS_MICORESHARED = "UPDATE_PAYMENT_TRANSACTION_PARAMS_MICORESHARED"
export const GET_PAYMENT_INFORMATION_END_MICORESHARED = "GET_PAYMENT_INFORMATION_END_MICORESHARED"
export const RESET_EMAIL_INFORMATION_MICORESHARED = "RESET_EMAIL_INFORMATION_MICORESHARED"
export const UPDATE_EMAIL_PARAMS_MICORESHARED = "UPDATE_EMAIL_PARAMS_MICORESHARED"
export const RESET_PAYMENT_TRANSACTION_PARAMS_MICORESHARED = "RESET_PAYMENT_TRANSACTION_PARAMS_MICORESHARED"
export const UPDATE_APPROVAL_INFORMATION_MICORESHARED="UPDATE_APPROVAL_INFORMATION_MICORESHARED"
export const GET_APPROVAL_INFORMATION_END_MICORESHARED="GET_APPROVAL_INFORMATION_END_MICORESHARED"
export const CLEAR_ACCOUNT_DETAILS_IN_APPROVAL_INFORMATION="CLEAR_ACCOUNT_DETAILS_IN_APPROVAL_INFORMATION"

export const UPDATE_MEMBER_UPLOAD_PARAMS_MICORESHARED="UPDATE_MEMBER_UPLOAD_PARAMS_MICORESHARED"
export const RESET_DOH_VERIFICATION_DETAILS="RESET_DOH_VERIFICATION_DETAILS_MICORESHARED"
///////cardbatch processing/////////////
export const UPDATE_MEDICAL_CARD_MEMBERS_SEARCH_PARAMS = 'UPDATE_MEDICAL_CARD_MEMBERS_SEARCH_PARAMS_MICORESHARED'
export const CLEAR_MEDICAL_CARD_MEMBERS_SEARCH = 'CLEAR_MEDICAL_CARD_MEMBERS_SEARCH'                   
export const UPDATE_MEDICAL_CARD_CHECKBOX_CHANGE = 'UPDATE_MEDICAL_CARD_CHECKBOX_CHANGE'
export const UPDATE_AFTER_BATCH_SUBMIT = 'UPDATE_AFTER_BATCH_SUBMIT'
export const UPDATE_CARD_BATCH_INFORMATION_PROPERTY = 'UPDATE_CARD_BATCH_INFORMATION_PROPERTY'
export const UPDATE_MEDICAL_CARD_MEMBERS_SEARCH_INFORMATION = 'UPDATE_MEDICAL_CARD_MEMBERS_SEARCH_INFORMATION'
export const CLEAR_CARD_BATCH_INFO = 'CLEAR_CARD_BATCH_INFO'
///////cardbatch processing/////////////
///////ExcelReportByDate/////////////   
export const UPDATE_EXPORT_REPORT_BY_DATE_PARAMS = 'UPDATE_EXPORT_REPORT_BY_DATE_PARAMS'
///////ExcelReportByDate/////////////   
export const GET_CASHIERS_MASTERS_END = 'GET_CASHIERS_MASTERS_END_MICORESHARED'
export const UPDATE_MICORE_MODULE_PERMISSIONS2_PARAMS_MICORESHARED="UPDATE_MICORE_MODULE_PERMISSIONS2_PARAMS_MICORESHARED"
export const GET_NAS_BATCH_DETAILS_END_MICORESHARED="GET_NAS_BATCH_DETAILS_END_MICORESHARED"


/*Change Product*/
export const UPDATE_CHANGE_PRODUCT_PARAMS_MICORESHARED = 'UPDATE_CHANGE_PRODUCT_PARAMS_MICORESHARED'
export const CLEAR_CHANGE_PRODUCT_PARAMS_MICORESHARED = 'CLEAR_CHANGE_PRODUCT_PARAMS_MICORESHARED'
export const UPDATE_PRODUCT_MASTERS_BY_VISA_EMIRATE_MICORESHARED = 'UPDATE_PRODUCT_MASTERS_BY_VISA_EMIRATE_MICORESHARED'
export const GET_PLANS_BY_PRODUCT_AND_PORTAL_PLAN_TYPE_ID_END_MICORESHARED = 'GET_PLANS_BY_PRODUCT_AND_PORTAL_PLAN_TYPE_ID_END_MICORESHARED'
export const UPDATE_CHANGE_ITEM_PARAMS_MICORESHARED = 'UPDATE_CHANGE_ITEM_PARAMS_MICORESHARED'
export const UPDATE_VISA_EMIRATES_MASTER_MICORESHARED = 'UPDATE_VISA_EMIRATES_MASTER_MICORESHARED'
export const UPDATE_PORTAL_PLAN_BY_PRODUCT_MICORESHARED = 'UPDATE_PORTAL_PLAN_BY_PRODUCT_MICORESHARED'
export const RESET_PRODUCT_MASTERS_BY_VISA_EMIRATE_MICORESHARED = 'RESET_PRODUCT_MASTERS_BY_VISA_EMIRATE_MICORESHARED'
export const RESET_PORTAL_PLAN_BY_PRODUCT_MICORESHARED = 'RESET_PORTAL_PLAN_BY_PRODUCT_MICORESHARED'
export const RESET_PLAN_BY_PRODUCT_MICORESHARED = 'RESET_PLAN_BY_PRODUCT_MICORESHARED'


/* NAS USER EDIT */
export const NAS_WORK_LOCATION_MASTER_MICORESHARED="NAS_WORK_LOCATION_MASTER_MICORESHARED"
export const NAS_RESIDENT_LOCATION_MASTER_MICORESHARED="NAS_RESIDENT_LOCATION_MASTER_MICORESHARED"
export const NAS_UPDATE_MEMBER_PARAMS ="NAS_UPDATE_MEMBER_PARAMS_MICORESHARED"
export const CLEAR_NAS_MEMBER_PARAMS ="CLEAR_NAS_MEMBER_PARAMS_MICORESHARED"
export const GET_NAS_MEMBER_DETAILS_END ="GET_NAS_MEMBER_DETAILS_END_MICORESHARED"
export const UPDATE_PLAN_BY_PRODUCT_MICORESHARED = 'UPDATE_PLAN_BY_PRODUCT_MICORESHARED'

/////job assignment for group quot and policy/////
export const UPDATE_JOB_ASSIGNMENT_FIELD = 'UPDATE_JOB_ASSIGNMENT_FIELD'
export const CLEAR_JOB_ASSIGNMENT_PARAMS = 'CLEAR_JOB_ASSIGNMENT_PARAMS'
export const CLEAR_JOB_ASSIGNMENT = 'CLEAR_JOB_ASSIGNMENT'
export const UPDATE_JOB_ASSIGNMENT_PARAMS = 'UPDATE_JOB_ASSIGNMENT_PARAMS'
export const UPDATE_JOB_ASSIGNMENT_SECTION_INFO = 'UPDATE_JOB_ASSIGNMENT_SECTION_INFO'
export const UPDATE_USER_MASTER_BY_GROUP = 'UPDATE_USER_MASTER_BY_GROUP'
export const UPDATE_TASK_USERS_MASTER = 'UPDATE_TASK_USERS_MASTER'
/////job assignment for group quot and policy/////

export const UPDATE_ALL_SEARCH_POLICY_SEARCH_RESULT_CHECKBOX_PARAMS = 'UPDATE_ALL_SEARCH_POLICY_SEARCH_RESULT_CHECKBOX_PARAMS'
export const UPDATE_SEARCH_POLICY_SEARCH_RESULT_CHECKBOX_PARAMS = 'UPDATE_SEARCH_POLICY_SEARCH_RESULT_CHECKBOX_PARAMS'


//documents listing
export const UPDATE_DOCUMENTS_LISTING_PARAMS_MICORESHARED = 'UPDATE_DOCUMENTS_LISTING_MICORESHARED'


//

export const  RESET_CUSTOM_TARRIF_UPLOAD = "RESET_CUSTOM_TARRIF_UPLOAD_MICORESHARED"
export const UPDATE_CUSTOM_TARIFF_RATES_PARAMS ="UPDATE_CUSTOM_TARIFF_RATES_PARAMS_MICORESHARED"
export const GET_CUSTOM_TARIFF_RATES_END ="GET_CUSTOM_TARIFF_RATES_END_MICORESHARED"
export const  UPDATE_TARIFF_RATES_PARAMS="UPDATE_TARIFF_RATES_PARAMS_MICORESHARED"
export const  GET_CATEGORIES_LIST_FROM_DOCUMENT_TOB="GET_CATEGORIES_LIST_FROM_DOCUMENT_TOB_MICORESHARED"

export const RESET_DOCUMENTS_LISTING_MICORESHARED = 'RESET_DOCUMENTS_LISTING_MICORESHARED'

export const GET_COC_BATCH_DETAILS_END_MICORESHARED = 'GET_COC_BATCH_DETAILS_END_MICORESHARED'
export const GET_MEMBER_SHAFAFIYA_HIST_END = "GET_MEMBER_SHAFAFIYA_HIST_END"
export const CLEAR_MEMBER_SHAFAFIYA_HIST = "CLEAR_MEMBER_SHAFAFIYA_HIST"

export const GET_ICP_BATCH_DETAILS_END_MICORESHARED = 'GET_ICP_BATCH_DETAILS_END_MICORESHARED'
export const GET_ICP_POLICY_BATCH_DETAILS_END_MICORESHARED = 'GET_ICP_POLICY_BATCH_DETAILS_END_MICORESHARED'

//GROUP RENEWAL
export const UPDATE_GROUP_RENEWAL_SEARCH_PARAMS_MICORESHARED = 'UPDATE_GROUP_RENEWAL_SEARCH_PARAMS_MICORESHARED'
export const CLEAR_GROUP_RENEWAL_SEARCH_PARAMS_MICORESHARED = 'CLEAR_GROUP_RENEWAL_SEARCH_PARAMS_MICORESHARED'
export const SHOW_GROUP_RENEWAL_SEARCH_RESULTS_MICORESHARED = 'SHOW_GROUP_RENEWAL_SEARCH_RESULTS_MICORESHARED'
export const UPDATE_GROUP_RENEWAL_SEARCH_RESULT_MICORESHARED = 'UPDATE_GROUP_RENEWAL_SEARCH_RESULT_MICORESHARED'
export const SHOW_GROUP_RENEWAL_TABLE_SEARCH_RESULTS_MICORESHARED = 'SHOW_GROUP_RENEWAL_TABLE_SEARCH_RESULTS_MICORESHARED'
//GROUP RENEWAL
export const GET_MEDICAL_OLD_AGE_CUT_OFF_DATE_MICORESHARED = 'GET_MEDICAL_OLD_AGE_CUT_OFF_DATE_MICORESHARED'

export const GET_TREATY_MASTERS_END_MICORESHARED = 'GET_TREATY_MASTERS_END_MICORESHARED'


